import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import Tabs from '@/components/common/Tabs.vue'
  import CompanyCourses from '@/components/course/CompanyCourses.vue'
  import ExternalCourses from '@/components/course/ExternalCourses.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

  import useCourse from '@/composables/useCourse'
  import useI18n from '@/composables/useI18n'

  import CookieHelper from '@/helpers/CookieHelper'

  import { UserModule } from '@/store/modules/user'
  import { CourseModule } from '@/store/modules/course'

  import type { PropType } from 'vue'
  import type { CourseItem, CoursePackage } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AssignUserCourseModal',
  props: {
    user: {
      type: Object as PropType<{ id: string; name: string; email: string }>,
      required: true,
    },
  },
  setup(__props) {

  

  const { groupCourses } = useCourse()
  const { translateString } = useI18n()

  const groupedExternalCourses = ref({} as { [key: string]: (CourseItem | CoursePackage)[] })
  const groupedOwnedCourses = ref({} as { [key: string]: (CourseItem | CoursePackage)[] })
  const activeTabIndex = ref(0)
  const submitCompanyCourses = ref(false)
  const submittingCompanyCourses = ref(false)
  const disableSubmitCoursesCTA = ref(true)

  const coursesOwnedByCompany = computed(() => CourseModule.coursesOwnedByCompany)
  const coursesOwnedByCompanySize = computed(() => {
    return Object.values(groupedOwnedCourses.value).flat().length
  })

  const hasCompanyOwnedCourses = computed(
    () =>
      coursesOwnedByCompany.value.length && isActiveTab.value(translateString('homepage.assignedCourses.ownCourses')),
  )

  const externalCourses = computed(() => CourseModule.externalCourses)
  const externalCoursesSize = computed(() => {
    return Object.values(groupedExternalCourses.value).flat().length
  })

  const tabs = computed(() => {
    const _tabs = []

    if (coursesOwnedByCompany.value.length) {
      _tabs.push(
        `${translateString('homepage.assignedCourses.ownCourses')} <span>${coursesOwnedByCompanySize.value}</span>`,
      )
    }

    if (externalCourses.value.length) {
      _tabs.push(
        `${translateString('homepage.assignedCourses.externalCourses')} <span>${externalCoursesSize.value}</span>`,
      )
    }

    return _tabs
  })

  const isActiveTab = computed(() => (name: string) => tabs.value[activeTabIndex.value].startsWith(name))

  const purchasedCourseIds = CookieHelper.getCookieValue('purchased_course_id')

  purchasedCourseIds?.forEach((courseId: string) => {
    const purchasedCourse = CourseModule.memberCourses?.find((c) => c.id === courseId)
    if (purchasedCourse) {
      if (purchasedCourse.purchased) {
        CookieHelper.removeCookie('purchased_course_id')
      } else {
        purchasedCourse.purchased = true
      }
    }
  })

  groupCourses(externalCourses.value).then((data) => {
    groupedExternalCourses.value = data
  })

  groupCourses(coursesOwnedByCompany.value).then((data) => {
    groupedOwnedCourses.value = data
  })

  const isPurchasedCourse = computed(
    () => (courseId: string) => CourseModule.purchasedMemberCourses.some((c) => c.id === courseId),
  )

  const isPurchasedBundle = computed(() => (bundle: CoursePackage) => bundle.courses.every((c) => c.purchased))

  const isPurchasedItem = computed(() => (item: CourseItem | CoursePackage) => {
    return (item as CourseItem).id
      ? isPurchasedCourse.value((item as CourseItem).id)
      : isPurchasedBundle.value(item as CoursePackage)
  })

  const headerTitle = computed(() => {
    return (key: string) => {
      if (key === 'purchased') return translateString('homepage.assignedCourses.alreadyPurchased')
      if (key === 'trial') return translateString('homepage.assignedCourses.inTrial')
      if (key === 'bundles') return translateString('homepage.assignedCourses.completePackages')

      return translateString('homepage.assignedCourses.otherTrainings')
    }
  })

  const getUserActivity = (courseId?: string) => {
    if (!courseId) return

    return UserModule.userCourseActivities?.find((c) => c.courseId === courseId)
  }

return { __sfc: true,groupCourses, translateString, groupedExternalCourses, groupedOwnedCourses, activeTabIndex, submitCompanyCourses, submittingCompanyCourses, disableSubmitCoursesCTA, coursesOwnedByCompany, coursesOwnedByCompanySize, hasCompanyOwnedCourses, externalCourses, externalCoursesSize, tabs, isActiveTab, purchasedCourseIds, isPurchasedCourse, isPurchasedBundle, isPurchasedItem, headerTitle, getUserActivity, computed, ref, Tabs, CompanyCourses, ExternalCourses, KetchUpButton, LoadingSpinner, useCourse, useI18n, CookieHelper, UserModule, CourseModule }
}

})